<template>
  <OmtLayoutHeaderFooter :footer="false" :header="{ titleLabel: 'Cadastro de biometria' }">
    <OmtLayoutContainer>
      <OmtRow>
        <BiometryAuthHeader />
      </OmtRow>

      <OmtRow mb="24px">
        <BiometryAuthCard />
      </OmtRow>

      <OmtRow>
        <BiometryCameraButton
          :disabled="alreadyRegistered"
          :confirmUser="true"
          :nameUser="nomeIdentificacao"
          buttonLabel="Começar"
          @success="handleBiometryCameraSuccess"
          @error="handleBiometryCameraError"
          @resourceError="handleResourceError"
          @startLoading="$root.$emit('show-loading')"
          @endLoading="$root.$emit('hide-loading')"
        />
      </OmtRow>
    </OmtLayoutContainer>
    <FeedbackModal
      v-if="modalInfos"
      :protocol="modalInfos.protocol"
      :title="modalInfos.title"
      :cardTitle="modalInfos.cardTitle"
      :cardDescription="modalInfos.cardDescription"
      :cardIcon="modalInfos.cardIcon"
      :modalIconBind="modalInfos.modalIconBind"
      :buttonLabel="modalInfos.buttonLabel"
      :secondButtonLabel="modalInfos.secondButtonLabel"
      @buttonClick="modalInfos.buttonClick"
      @close="modalInfos.close"
      @secondButtonClick="modalInfos.secondButtonClick"
    />
    <LoadingModal v-if="process" :title="process.title" :description="process.description" :loading="true" />
  </OmtLayoutHeaderFooter>
</template>

<script>
import LoadingModal from "@/components/Organisms/LoadingModal";
import BiometryCameraButton from "@/components/Organisms/Biometry/BiometryCameraButton";
import BiometryAuthHeader from "@/components/Organisms/Biometry/BiometryAuthHeader.vue";
import FeedbackModal from "@/components/Molecules/FeedbackModal";
import BiometryAuthCard from "@/components/Organisms/Biometry/BiometryAuthCard";
import { mapActions, mapState } from "vuex";

export default {
  components: {
    LoadingModal,
    BiometryCameraButton,
    FeedbackModal,
    BiometryAuthCard,
    BiometryAuthHeader
  },
  data() {
    return {
      timer: null,
      modalToShow: "",
      process: null,
      alreadyRegistered: false,
      alreadyRegisteredProtocol: null,
      justRegisteredProtocol: null
    };
  },
  computed: {
    ...mapState("firstAccess", ["autenticado", "cadastrarEmail", "hash", "nomeIdentificacao"]),
    modals() {
      return {
        OnErrorModal: {
          title: "Não foi possível continuar",
          cardTitle: "Não foi possível detectar a câmera para captura",
          cardDescription:
            "Acesse os ajustes do seu smartphone e permita que o nosso app acesse sua câmera, ou realize a biometria em outro dispositivo.",
          cardIcon: "circle-exclamation",
          modalIconBind: {
            name: "circle-xmark",
            color: "var(--colors-light-primary-navy-blue)"
          },
          buttonLabel: "Entendi",
          buttonClick: this.handleCloseModalAndLeave,
          close: this.handleCloseModalAndLeave
        },
        SucessfullyRegistereBiometryModal: {
          title: "Biometria cadastrada com sucesso!",
          cardTitle: "Agora sua biometria está registrada no app",
          cardDescription: "Seu acesso, informações e transações já estão protegidos com o reconhecimento facial.",
          cardIcon: "face-viewfinder",
          modalIconBind: {
            name: "check-circle",
            color: "var(--colors-light-support-success)"
          },
          buttonLabel: "Concluir",
          buttonClick: this.handleCloseModalOnSucessfully,
          close: this.handleCloseModalOnSucessfully
        }
      };
    },
    modalInfos() {
      if (!this.modalToShow) return null;
      const result = this.modals[this.modalToShow];
      if (result) {
        result.secondButtonClick = this.handleCloseModalAndLeave;
        if (this.modalToShow !== "Ops") {
          result.protocol = this.alreadyRegisteredProtocol;
        }
      }
      return result;
    }
  },
  mounted() {
    if (!this.hash) {
      this.$router.replace({
        name: "first-access.terms"
      });
      return;
    }
  },
  beforeDestroy() {
    if (this.timer) clearInterval(this.timer);
  },
  methods: {
    ...mapActions("firstAccess", ["saveFace", "fetchFaceStatus", "registerError"]),
    async handleBiometryCameraSuccess(payload) {
      const { encrypted } = payload;

      try {
        this.loadSituation();
        const data = await this.saveFace({ selfie: encrypted });
        const { ImagemAceita, MensagemErro, Protocolo } = data;

        if (!!ImagemAceita && !MensagemErro && !!Protocolo) {
          this.showSucessfullyRegistereBiometryModal = true;
          this.alreadyRegistered = true;
          this.justRegisteredProtocol = Protocolo;
          const waitTime = 1000; // 1s
          this.timer = setInterval(() => this.loadSituation(), waitTime);
          await this.$root.$emit("hide-loading");
        } else {
          this.quitLoadSituationProcess();
          this.$toast({
            description: MensagemErro ?? "Ocorreu um erro ao salvar a biometria",
            status: "error",
            duration: 10000,
            position: "top"
          });
        }
      } catch (error) {
        this.quitLoadSituationProcess();
        this.handleError(error);
      }
    },
    quitLoadSituationProcess() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
      this.process = null;
    },
    async loadSituation() {
      if (this.process === null) {
        this.process = {
          step: 1,
          title: "Validando biometria...",
          description: "Por favor, aguarde. Esta etapa pode levar até 15 segundos."
        };
      } else if (this.process.step > 15) {
        this.quitLoadSituationProcess();
        this.handleCloseModalAndLeave();
      } else {
        this.process.step++;
        if (this.process.step % 5 === 0) {
          try {
            if (this.process.step >= 15 && this.timer) {
              clearInterval(this.timer);
              this.timer = null;
            }
            const data = await this.fetchFaceStatus();
            const { Gerado, Aceito, Protocolo } = data;
            if (Gerado && !Aceito && this.process.step < 15) {
              return;
            }
            this.alreadyRegistered = Gerado;
            this.alreadyRegisteredProtocol = Protocolo;

            this.quitLoadSituationProcess();
            if (!Gerado) {
              this.handleCloseModalAndLeave();
              return;
            }

            if (Aceito) {
              this.modalToShow = "SucessfullyRegistereBiometryModal";
              return;
            }
            this.handleCloseModalAndLeave();
          } catch (error) {
            this.handleError(error);
          }
        } else {
          if (this.process.step === 7) {
            this.process = {
              step: 7,
              title: "Validando biometria...",
              description: "Por favor, aguarde. Estamos concluindo a validação."
            };
          }
        }
      }
    },
    async handleError(error) {
      await this.$root.$emit("hide-loading");
      window.$log.error("biometry page", error);
      this.handleCloseModalAndLeave();
    },
    async handleResourceError(error) {
      const response = await this.registerError({ cod: "init", dsc: JSON.stringify(error) });
      this.justRegisteredProtocol = response.Protocolo;
      this.modalToShow = "OnErrorModal";
    },
    handleBiometryCameraError(error) {
      window.$log.error("biometry camera", error);
      this.registerError({ cod: "camera", dsc: JSON.stringify(error) });
    },
    handleCloseModalAndLeave() {
      this.$router.push({ name: this.cadastrarEmail ? "first-access.mailform" : "first-access.mailcheck" });
    },
    handleCloseModalOnSucessfully() {
      this.$router.push({ name: this.cadastrarEmail ? "first-access.mailform" : "first-access.password" });
    }
  }
};
</script>
